<template>
  <div class="detail-spbu">
    <div class="detail-spbu__banner">
      <div v-if="imgLoaded" class="detail-spbu__banner__action">
        <div class="detail-spbu__banner__action__saved">
          <button class="btn-regular secondary" @click="saved">
          <i class="adx-ic_plus"></i>
          <span>Save</span>
          </button>
        </div>
        <div class="detail-spbu__banner__action__viewphoto">
          <button class="btn-regular secondary" @click="toggle" :disabled="!isPhotosAvailable">
            View Photos
          </button>
        </div>
      </div>
      <div v-else class="detail-spbu__banner__noaction">
        <div class="detail-spbu__banner__noaction__saved">
          <button class="btn-regular secondary" @click="saved">
          <i class="adx-ic_plus"></i>
          <span>Save</span>
          </button>
        </div>
        <div class="detail-spbu__banner__noaction__viewphoto">
          <button class="btn-regular secondary" @click="toggle" :disabled="!isPhotosAvailable">
            View Photos
          </button>
        </div>
      </div>
      <adx-detail-slider :class="isPhotosAvailable ? 'detail-spbu__banner__img' : 'detail-spbu__banner__placeholder'" 
      :slide="1" :isDetail="true" :isCenterMobile="false" :arrowMobile="false" :data="isPhotosAvailable ? detailSlider : placeholderImage" />
    </div>
    <div v-if="!infoLoaded" class="loading-container">
      <adx-loading />
    </div>
    <div v-else class="detail-spbu__info">
      <div class="detail-spbu__info__left">
        <div class="detail-spbu__info__left__header">
          <adx-label-custom :color="'#ff7444'" :label="'SPBU'"/>
          <h2 class="large-title title">{{spbuDetail.title}}</h2>
          <span class="detail-spbu__info__left__header--placement subhead">{{type}} . {{spbuDetail.placement}}</span>
        </div>
         <div class="detail-spbu__info__left__about">
          <div class="detail-spbu__info__left__about__title">
            <span class="regular-font">Media Package</span>
          </div>
          <div class="detail-spbu__info__left__about__content">
            <p class="subhead">{{spbuDetail.description}}</p>
          </div>
        </div>
        <div class="detail-spbu__info__left__media">
          <div class="detail-spbu__info__left__media__title">
            <span>Media Package</span>
          </div>
          <div class="detail-spbu__info__left__media__content">
            <div v-if="media.size" class="detail-spbu__info__left__media__content--item" >
              <span>Size</span>
              <span class="value">{{media.size}} m</span>
            </div>
            <div v-if="media.material" class="detail-spbu__info__left__media__content--item">
              <span>Material</span>
              <span class="value">{{media.material}}</span>
            </div>
            <div v-if="media.spot" class="detail-spbu__info__left__media__content--item">
              <span>Total Spot</span>
              <span class="value">{{media.spot}}</span>
            </div>
            <div  v-if="media.placement" class="detail-spbu__info__left__media__content--item">
              <span>Placement</span>
              <span class="value">{{media.placement}}</span>
            </div>
          </div>
        </div> -->
        <div class="detail-spbu__info__left__about">
          <div class="detail-spbu__info__left__about__title">
            <span class="regular-font">About Location</span>
          </div>
          <div class="detail-spbu__info__left__about__content">
            <p class="subhead">{{spbuDetail.locDesc}}</p>
          </div>
        </div>
        <div class="detail-spbu__info__left__operatinghour">
          <div class="detail-spbu__info__left__operatinghour__title">
            <span class="regular-font">Operation Hours</span>
          </div>
          <div class="detail-spbu__info__left__operatinghour__content">
            <div class="detail-spbu__info__left__operatinghour__content--item" v-for="(operatinghour, index) in OperatingHours" :key="index">
              <span class="days">{{operatinghour.day}}</span>
              <span :class="['times', operatinghour.isOpen ? '' : 'day-close', 'subhead']">{{operatinghour.time}}</span>
            </div>
          </div>
        </div>
        <div class="detail-spbu__info__left__surrounding">
          <div class="detail-spbu__info__left__surrounding__title">
            <span class="regular-font">Surrounding</span>
          </div>
          <div class="detail-spbu__info__left__surrounding__content">
            <p class="subhead">{{spbuDetail.surrounding}}</p>
          </div>
        </div>
        <div class="detail-spbu__info__left__traffic">
          <div class="detail-spbu__info__left__traffic__title">
            <span class="regular-font">Traffic</span>
          </div>
          <div class="detail-spbu__info__left__traffic__content">
            <span>Monthly Traffic : {{getVisitor}} Visitors</span>
          </div>
          <!-- <div class="detail-spbu__info__left__traffic__content" v-for="(demographic, index) in demographics" :key="index">
            <i :class="demographic.icon"></i>
            <span class="item">{{demographic.text}}</span>
          </div> -->
          <div v-if="traffic.spending" class="detail-spbu__info__left__traffic__content">
            <i class="adx-ic_cards"></i>
            <span class="item">Average Spending  {{traffic.spending | formatMoney}} /person/visit</span>
          </div>
          <div v-if="traffic.occupation" class="detail-spbu__info__left__traffic__content">
            <i class="adx-ic_briefcase"></i>
            <span class="item">{{traffic.occupation}}</span>
          </div>
          <div v-if="traffic.visitor_profile" class="detail-spbu__info__left__traffic__content">
            <i class="icon-knowledge-base"></i>
            <span class="item">{{traffic.visitor_profile}}</span>
          </div>
        </div>
      </div>
      <div class="detail-spbu__info__right">
        <div class="detail-spbu__info__right__price">
          <h4 class="subhead title">Price / day</h4>
          <h3 class="medium-title price">{{spbuDetail.price|formatMoney}}</h3>
        </div>
        <div class="detail-spbu__info__right__forbidden">
          <div class="detail-spbu__info__right__forbidden--title">
            <i class="icon-warning"></i>
            <span>Forbidden Advertisement</span>
          </div>
          <div class="detail-spbu__info__right__forbidden--content">
            <p>{{spbuDetail.forbidden}}</p>
          </div>
        </div>
         <div class="detail-spbu__info__right__address">
          <div class="detail-spbu__info__right__address--title">
            <i class="icon-pin"></i>
            <span>Address</span>
          </div>
          <div class="detail-spbu__info__right__address--content">
            <p>{{spbuDetail.address}}</p>
          </div>
        </div>
        <div class="detail-spbu__info__right__action">
          <button class="btn-large primary add" @click="showCampaign">Add to Campaign</button>
        </div>
      </div>
    </div>
    <div v-if="infoLoaded" class="detail-spbu__footer">
      <div class="detail-spbu__footer__left">
        <p class="micro-font title">Price / day</p>
        <p class="medium-title price">{{spbuDetail.price|formatMoney}}</p>
      </div>
      <div class="detail-spbu__footer__right">
        <button class="btn-large btn-block primary" @click="showCampaign">Add to Campaign</button>
      </div>
    </div>
    <adx-modal v-if="isOpen" @modal-close="toggle" :type="`full`" :color="`transparant`">
      <div slot="content" class="content">
        <adx-detail-slider :isImageShow="true" :slide="1" :arrowMobile="true" @current="getCurrent" @init="getCount" :data="detailSlider" />
        <div class="modal__wrapper__footer">
          <span class="left">Image {{currentSlide}} of {{countSlide}} </span> <span class="right"> - {{spbuDetail.title}}</span>
        </div>
      </div>
    </adx-modal>
  </div>
</template>

<script>
import DetailSlider from '@/components/Slider/DetailSlider'
import LoadingSecondary from '@/components/Loading/Secondary'
import LoadingSpin from '@/components/Loading/Secondary-white'
import LoadingPrimary from '@/components/Loading/Primary'
import Modal from '@/components/Modal'
import LabelStatusCustom from '@/components/StatusLabelCustom'
import api from '@/api'
import { apiV2 } from '@/api/urls'
import { formatNumber } from '@/lib/filter'
import { mapGetters, mapActions, mapMutations } from 'vuex'

export default {
  name: 'adx-detail-page',
  components: {
    'adx-detail-slider': DetailSlider,
    'adx-loading-circle': LoadingSecondary,
    'adx-loading-spin': LoadingSpin,
    'adx-loading': LoadingPrimary,
    'adx-modal': Modal,
    'adx-label-custom': LabelStatusCustom
  },
  props: {

  },
  data() {
    return {
      type: 'Experience Branding',
      isLoadingCampaign: true,
      isLoadingAppend: [],
      isCreateCampaign: false,
      isMobile: window.innerWidth < 769,
      isShownCampaign: false,
      campaigns: [],
      spbuDetail: {
        title: ``,
        placement: ``,
        description: ``,
        locDesc:``,
        surrounding: ``,
        forbidden: ``,
        address: ``,
        price: null,
      },
      traffic:{
        visitor: null,
        spending: null,
        occupation: null,
        visitor_profile: null,
      },
      media: {
        size: ``,
        material: ``,
        spot: null,
        placement: ``,
      },
      OperatingHours: [],
      detailSlider: [],
      occupation: ``,
      isOpen: false,
      currentSlide: 1,
      countSlide: null,
      pub_id: null,
      deviceId: null,
      imgLoaded: false,
      infoLoaded: false,
      savedLoading: false,
      placeholderImage:[{
        id: 0,
        url: `/img/notfound/img-placeholder_landscape.jpg`,
        thumbnail : `/img/notfound/img-placeholder_landscape.jpg`,
        is_primary: false,
        caption: 'placeholder'
      }],
    }
  },
  computed: {
    ...mapGetters ({
      defaultSaved: 'default',
      token: 'token'
    }),
    isPhotosAvailable(){
      return this.detailSlider.length > 0
    },
    getVisitor: function() {
      return this.traffic.visitor * 30 
    }
  },
  watch: {

  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {
    const { pub_id } = this.$route.params
    this.pub_id = pub_id
    this.loadData()
    this.loadImage()
  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    showCampaign(){
      if (this.token) {
        this.isShownCampaign = true
        this.getCampaigns()
      } else {
        this.$router.push({name: 'signin', query: { next: this.$route.fullPath }})
      }
    },
    getCampaigns() {
      if (this.campaigns.length == 0){
        (async () => {
          this.isLoadingCampaign = true
          const response = await api.get(apiV2.draftCampaigns, { needToken: true })
          this.isLoadingCampaign = false
          if (response.status == 200) {
            this.campaigns = response.data
          } else {
            // this.error = response.data.error
          }
        })();
      }
    },
    loadData () {
      (async () => {
        const { data } = await api.get(apiV2.experienceBrandingDetail(this.pub_id), { needToken: true })
        this.mapData(data)
        this.infoLoaded = true
      })();
    },
    loadImage () {
      (async () => {
        this.detailSlider = []
        const { data } = await api.get(apiV2.exBrandingDetailImage(this.pub_id), { needToken: true })
        let image = []
        let isPrimaryExist = false
        data.map(el => {
          if(el.is_primary){
            isPrimaryExist = true
            image.push({
              id: el.id,
              url: el.image,
              thumbnail : el.thumbnail_720,
              is_primary: el.is_primary,
              caption: el.caption
            })
          }
        })
        this.imgLoaded = true
        if (!isPrimaryExist && data.length > 0){
          let firstPic = data[0]
          this.detailSlider.push({
            id: firstPic.id,
            url: firstPic.image,
            thumbnail : firstPic.thumbnail_720,
            is_primary: firstPic.is_primary,
            caption: firstPic.caption
          })
        } else if (image.length > 0) {
          this.detailSlider.push(image[0])
        }
      })();
    },
    mapData (data) {
      this.spbuDetail = {
        title: data.title,
        placement: data.placement,
        description: data.description,
        locDesc: data.location_inside.about,
        surrounding: data.surround.name,
        forbidden: (data.forbidden_ads ? data.forbidden_ads : 'There\'s no forbidden ads'),
        address: (data.address ? data.address : 'N/A'),
        price: data.price
      }
      this.traffic = {
        visitor: data.location_inside.traffic,
        spending: data.location_inside.spending_average,
        occupation: ` Occupation ${data.profile.job.join(` `)}`,
        visitor_profile: ` Visitor Profile ${data.profile.ses.join(` `)}`,
      },
      this.media = {
        size: data.size,
        material: data.material,
        spot: data.quantity,
        placement: data.placement
      }
      this.OperatingHours = data.operating_hours.map(el => {
        let data = {}
        data.day = el.day
        data.isOpen = el.is_open
        if (el.is_open) {
          data.time = `${el.start} - ${el.end}`
        } else {
          data.time = 'closed'
        }
        return data
      })
    },
    iconSelection(id) {
      const listSaved = this.defaultSaved[this.category]
      const isLogin = this.token
      if(isLogin && listSaved){
        if (listSaved.includes(id)) {
          return 'adx-ic_check'
        } else {
          return 'adx-ic_plus'
        }
      } else {
        return 'adx-ic_plus'
      }
    },
    toggle() {
      this.isOpen = !this.isOpen
    },
    saved() {
      this.$notify({
        group: 'saved',
        title: 'Success',
        text: `Data successfully saved!`,
        type: 'success'
      });
    },
    getCurrent(item) {
      this.currentSlide = item + 1
    },
    getCount(item) {
      this.countSlide = item
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';

</style>

<style lang="scss">
@import '~@/styles/variables';
@import '~@/styles/mixins';

.detail-spbu__banner__placeholder {
  .slick-slide {
    img.detail {
      object-fit: unset;
    }
  }
}

.detail-spbu__banner__img {

  .slick-slide {
    widows: 100;
  }
  .slick-slide:first-child{
    margin-left: 0px;
  }
}

@include breakpoint(md) {
  .detail-spbu__banner__img {
    .slick-slide {
      img.detail {
        height: 260px;
      }
    }
  }
  .detail-spbu__banner__placeholder {
    .slick-slide {
      img.detail {
        height: 260px;
      }
    }
  }
}
</style>
